import { useCallback } from 'react';
import dev from '../resources/i18n/dev.json';
import esAR from '../resources/i18n/es-AR.json';
import esCL from '../resources/i18n/es-CL.json';
import esCO from '../resources/i18n/es-CO.json';
import esEC from '../resources/i18n/es-EC.json';
import esPE from '../resources/i18n/es-PE.json';
import ptBR from '../resources/i18n/pt-BR.json';
import deDE from '../resources/i18n/de-DE.json';

const languages = {
  'es-ar': esAR,
  'es-cl': esCL,
  'es-co': esCO,
  'es-ec': esEC,
  'es-pe': esPE,
  'pt-br': ptBR,
  'de-de': deDE
};

export function useTranslation() {
  const language = `${process.env.COUNTRY}`;
  const translate = useCallback((key, values = {}) => {
    const translations = { ...dev, ...languages[language] };
    const translation = translations[key] || key;

    return Object.keys(values).reduce((acc, value) => {
      return acc.replace(new RegExp(`{{${value}}}`, 'g'), values[value]);
    }, translation);
  }, []);

  return [translate];
}
